<template>
    <div id="emerge-end" class="mt--100 mb--100">
        <!--=====================================-->
        <!--=        Brand Area Start       	=-->
        <!--=        Brand Area Start       	=-->
        <!--=====================================-->
        <section class="section" data-sal="slide-up" data-sal-duration="800">
            <div class="container">
                <div class="section-heading">
                    <h2 class="title font-weight-100">Crece tu dinero <br> mientras <span class="bold">refrescas</span><br> al planeta.</h2>
                    <span class="subtitle black bold"><span class="emerge-red">EMERGE</span> es una cooperación de:</span>
                </div>
                <div class="align-items-center justify-content-center row">
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500">
                        <div class="brand-grid">
                            <img :src="`${logoBase}femsa.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="100">
                        <div class="brand-grid">
                            <img :src="`${logoBase}coop-alemania.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200">
                        <div class="brand-grid">
                            <img :src="`${logoBase}giz.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300">
                        <div class="brand-grid">
                            <img :src="`${logoBase}developpp.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400">
                        <div class="brand-grid">
                            <img :src="`${logoBase}redgirasol.png`" alt="Brand">
                        </div>
                    </div>
                </div>
                <button @click.stop="goToInvestorRegister" class="axil-btn btn-borderd p-4 bg-emerge-red border-emerge-red mt--80">Comenzar ahora</button>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "EmergeEnd",
        data: () => ({
            logoBase: "https://cdn.redgirasol.com/nuevo_portal/emerge/logos/logo-",
        }),
        props: {
            source: String
        }
    }
</script>

<style scoped>

.container {
    text-align-last: center;
}

</style>